import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterH: any = null,
    sceneTextLeaveH: any = null;
export default function H() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const LOCAL_SITES: string[] = ['jp'];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterH) {
                    AniContainer.removeScene(sceneTextEnterH);
                    sceneTextEnterH = null;
                }
                if (sceneTextLeaveH) {
                    AniContainer.removeScene(sceneTextLeaveH);
                    sceneTextLeaveH = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterH = AniContainer.create({
                    triggerElement: '.dpu-detail-H',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveH = AniContainer.create({
                //     triggerElement: '.dpu-detail-H .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 2,
                //     onLeave: () => setTextEnter(false),
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterH) {
                    AniContainer.removeScene(sceneTextEnterH);
                    sceneTextEnterH = null;
                }
                if (sceneTextLeaveH) {
                    AniContainer.removeScene(sceneTextLeaveH);
                    sceneTextLeaveH = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-H dpu-detail-section ${css['dpu-detail-H']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secH_subtitle')}</p>
                <h2 className="title">{t('secH_title')}</h2>
                <p className="desc">{t('secH_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/delta-pro-ultra/launch/8${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcPad={`/responsive/picture/delta-pro-ultra/launch/8_768${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcMobile={`/responsive/picture/delta-pro-ultra/launch/8_768${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                    alt={t('secH_title')}
                />
            </div>
        </section>
    );
}
